import { revealCardRegions, waitForCardElement } from '../../use/useBoardResidency';
import { Action } from '@/_core/fluxstore/types';
import { StorymapState, ViewType } from '../../types';
import * as smUse from '../../use';
import { useStorymapStore } from '../../useModule';
import * as storymapStoreModule from '../../../store';

const { registerReducer, dispatch } = useStorymapStore();

// How long a flashed card is watched for coming into view.
const FLASH_WATCH_MS = 10000;

export class SetActiveCardIdByClick extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetActiveCardIdByClick';

    public constructor(public cardId: string, public options?: { expandRelease?: boolean; expandActivity?: boolean; flashCard?: boolean }) {
        super(SetActiveCardIdByClick.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: StorymapState, action: SetActiveCardIdByClick): void => {
    const card = smUse.getActiveCard();

    if (state.currentViewType === ViewType.Tracking) {
        state.navigationState.originalSubtask = null;
        state.navigationState.shouldKeepOriginalCardRectOnSelectionChange = false;
    }

    // if (card) {
    //     card.isActive = false;
    // }

    if (action.cardId) {
        // setTimeout(() => {

        // }, 0);

        const cardToSet =
            state.activities.find((x) => x.id == action.cardId) ??
            state.tasks.find((x) => x.id == action.cardId) ??
            state.subtasks.find((x) => x.id == action.cardId);

        if (cardToSet) {
            if (action.options?.expandRelease && smUse.isSubtask(cardToSet)) {
                dispatch(new storymapStoreModule.SetReleaseIsCollapsed(cardToSet.releaseId, false));
            }
            if (action.options?.expandActivity && (smUse.isTask(cardToSet) || smUse.isSubtask(cardToSet))) {
                dispatch(new storymapStoreModule.SetActivityIsCollapsed(cardToSet.activityId, false));
            }

            if (action.options?.flashCard) {
                const scrollContainer = document.querySelector('.storymap-scroll-container');
                if (smUse.isSubtask(cardToSet)) {
                    revealCardRegions(cardToSet.releaseId, cardToSet.activityId);
                }

                waitForCardElement(action.cardId).then((cardElement) => {
                    if (!cardElement) {
                        return;
                    }
                    const observer = new IntersectionObserver(
                        (entries) => {
                            for (const entry of entries) {
                                if (entry.isIntersecting) {
                                    setTimeout(() => {
                                        cardElement.classList.add('bounce-highlight');

                                        setTimeout(() => {
                                            cardElement.classList.remove('bounce-highlight');
                                        }, 1000);
                                    }, 50); //without the delay the class is removed if the card is already visible immediately possibly because of rerendering

                                    observer.disconnect();
                                }
                            }
                        },
                        {
                            root: scrollContainer,
                            rootMargin: '0px',
                            threshold: 0.5, // how much of the card must be visible
                        }
                    );
                    observer.observe(cardElement);
                    // A card that never comes into view, or a board that goes away first, must not keep the observer and the element.
                    setTimeout(() => observer.disconnect(), FLASH_WATCH_MS);
                });
            }

            setTimeout(() => {
                const card = smUse.getActiveCard();
                if (card && card.id != action.cardId) {
                    card.isActive = false;
                }
                cardToSet.isActive = true;
            }, 0);
        }
    }

    if (card && card.id != action.cardId) {
        card.isActive = false;
    }

    //state.activeCardId = action.cardId;
};

//@ts-ignore
registerReducer(SetActiveCardIdByClick.ACTION_TYPE, reducer);
